import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Selector, Store } from '@ngrx/store';
import { ApiRootFacade, apiRootFeatureState, ApiRootLinkRel, ApiRootResource } from '@schir-int-client/api-root';
import { VorgangFacade, VorgangResource } from '@schir-int-client/vorgang-shared';
import { Observable } from 'rxjs';
import { AccessibilityService } from '@schir-int-client/tech';
import { FrontendEnvironment, frontendEnvironment } from '@schir-int-client/environment';
import { TabTitle, TitleService } from '../../../../tech/src/lib/title/title.service';
import { AppState } from '../../../../../apps/int-client/src/app/shared/store/app-state.model';

@Component({
	selector: 'schir-int-client-dashboard-page',
	templateUrl: './dashboard-page.component.html',
	styleUrls: ['./dashboard-page.component.scss'],
	standalone: false,
})
export class DashboardPageComponent implements OnInit, AfterViewInit {
	apiRoot: Observable<ApiRootResource>;
	frontendEnvironment: Observable<FrontendEnvironment>;
	vorgaengeForRechtspflege: Observable<VorgangResource[]>;
	vorgaengeInRuecklauf: Observable<VorgangResource[]>;
	isLFPR: boolean;

	protected readonly ApiRootLinkRel = ApiRootLinkRel;

	constructor(
		private vorgangFacade: VorgangFacade,
		private store: Store<AppState>,
		private accessibilityService: AccessibilityService,
		public titleService: TitleService,
		private apiRootFacade: ApiRootFacade
	) {
		this.apiRoot = this.store.select(this.getApiRootState());
		this.frontendEnvironment = this.store.select(<any>frontendEnvironment);
		this.store = store;
		this.isLFPR = this.apiRootFacade.isLFPR;
	}

	ngOnInit(): void {
		// TODO Remove as soon as the window title configuration in eIP is updated
		this.titleService.setTitle(TabTitle.DASHBOARD);
		this.vorgaengeInRuecklauf = this.vorgangFacade.vorgaengeInRuecklauf;
		this.vorgaengeForRechtspflege = this.vorgangFacade.vorgaengeRechtspfleger;
	}

	ngAfterViewInit() {
		this.accessibilityService.focusElementById('search-input');
	}

	getApiRootState(): Selector<AppState, ApiRootResource | null> {
		return (state: AppState) => state[apiRootFeatureState].apiRoot;
	}

	moveFocus(event: KeyboardEvent) {
		if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
			return;
		}
		event.preventDefault();
		event.stopPropagation();

		const currentTarget = event.target as HTMLElement | null;
		const currentListItem = currentTarget?.closest('.vorgang-link') as HTMLElement | null;
		if (!currentListItem) {
			return;
		}

		const dashboard = event.currentTarget as HTMLElement | null;
		if (!dashboard) {
			return;
		}

		const columns = [
			Array.from(dashboard.querySelectorAll<HTMLElement>('schir-int-client-ruecklauf .vorgang-link')),
			Array.from(dashboard.querySelectorAll<HTMLElement>('schir-int-client-eingang-list .vorgang-link')),
			Array.from(dashboard.querySelectorAll<HTMLElement>('schir-int-client-wiedervorlage-list .vorgang-link')),
		];

		if (columns.some(items => !items.length)) {
			return;
		}

		const currentColumnIndex = columns.findIndex(items => items.includes(currentListItem));
		if (currentColumnIndex < 0) {
			return;
		}

		const currentColumn = columns[currentColumnIndex];
		const currentRowIndex = currentColumn.indexOf(currentListItem);

		switch (event.key) {
			case 'ArrowDown': {
				currentColumn[currentRowIndex + 1]?.focus();
				break;
			}
			case 'ArrowUp': {
				currentColumn[currentRowIndex - 1]?.focus();
				break;
			}
			case 'ArrowLeft': {
				const targetColumn = columns[currentColumnIndex - 1];
				targetColumn?.[Math.min(currentRowIndex, targetColumn.length - 1)].focus();
				break;
			}
			case 'ArrowRight': {
				const targetColumn = columns[currentColumnIndex + 1];
				targetColumn?.[Math.min(currentRowIndex, targetColumn.length - 1)].focus();
				break;
			}
		}
	}
}
